export default "__VITE_PUBLIC_ASSET__50e7c9fc__"